import React from 'react';

const Footer = () => {
    return (
        <div className="text-light bg-info py-2">
            <p className="pt-2">© 2021 All Rights Reserved</p>
        </div>
    );
};

export default Footer;